'use strict';

var FocalPoint = require('./focal-point');
var React = require('react');

var FocusTrap = React.createClass({
  displayName: 'FocusTrap',


  propTypes: {
    active: React.PropTypes.bool,
    onExit: React.PropTypes.func
  },

  getDefaultProps: function getDefaultProps() {
    return {
      active: true,
      className: 'focus-trap'
    };
  },
  render: function render() {
    var _props = this.props;
    var active = _props.active;
    var className = _props.className;
    var children = _props.children;
    var element = _props.element;
    var onExit = _props.onExit;


    if (!active) return null;

    return React.createElement(
      'div',
      { className: className + '-wrapper', onKeyUp: this._onKeyUp },
      React.createElement('div', { 'aria-hidden': 'true', className: className + '-backdrop', onClick: onExit }),
      React.createElement(
        FocalPoint,
        { ref: 'focus', className: className, element: element },
        children
      )
    );
  },
  _onKeyUp: function _onKeyUp(e) {
    if (e.key === 'Escape' && 'onExit' in this.props) {
      this.props.onExit();
    }
  }
});

module.exports = FocusTrap;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9mb2N1cy10cmFwLmpzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBLElBQUksYUFBYSxRQUFRLGVBQVIsQ0FBakI7QUFDQSxJQUFJLFFBQWEsUUFBUSxPQUFSLENBQWpCOztBQUVBLElBQUksWUFBWSxNQUFNLFdBQU4sQ0FBa0I7QUFBQTs7O0FBRWhDLGFBQVc7QUFDVCxZQUFTLE1BQU0sU0FBTixDQUFnQixJQURoQjtBQUVULFlBQVMsTUFBTSxTQUFOLENBQWdCO0FBRmhCLEdBRnFCOztBQU9oQyxpQkFQZ0MsNkJBT2Q7QUFDaEIsV0FBTztBQUNMLGNBQVksSUFEUDtBQUVMLGlCQUFZO0FBRlAsS0FBUDtBQUlELEdBWitCO0FBY2hDLFFBZGdDLG9CQWN2QjtBQUFBLGlCQUNnRCxLQUFLLEtBRHJEO0FBQUEsUUFDRCxNQURDLFVBQ0QsTUFEQztBQUFBLFFBQ08sU0FEUCxVQUNPLFNBRFA7QUFBQSxRQUNrQixRQURsQixVQUNrQixRQURsQjtBQUFBLFFBQzRCLE9BRDVCLFVBQzRCLE9BRDVCO0FBQUEsUUFDcUMsTUFEckMsVUFDcUMsTUFEckM7OztBQUdQLFFBQUksQ0FBQyxNQUFMLEVBQWMsT0FBTyxJQUFQOztBQUVkLFdBQ0U7QUFBQTtBQUFBLFFBQUssV0FBZ0IsU0FBaEIsYUFBTCxFQUE0QyxTQUFVLEtBQUssUUFBM0Q7QUFDRSxtQ0FBSyxlQUFZLE1BQWpCLEVBQXdCLFdBQWdCLFNBQWhCLGNBQXhCLEVBQWdFLFNBQVUsTUFBMUUsR0FERjtBQUVFO0FBQUMsa0JBQUQ7QUFBQSxVQUFZLEtBQUksT0FBaEIsRUFBd0IsV0FBWSxTQUFwQyxFQUFnRCxTQUFVLE9BQTFEO0FBQ0k7QUFESjtBQUZGLEtBREY7QUFRRCxHQTNCK0I7QUE2QmhDLFVBN0JnQyxvQkE2QnZCLENBN0J1QixFQTZCcEI7QUFDVixRQUFJLEVBQUUsR0FBRixLQUFVLFFBQVYsSUFBc0IsWUFBWSxLQUFLLEtBQTNDLEVBQWtEO0FBQ2hELFdBQUssS0FBTCxDQUFXLE1BQVg7QUFDRDtBQUNGO0FBakMrQixDQUFsQixDQUFoQjs7QUFvQ0EsT0FBTyxPQUFQLEdBQWlCLFNBQWpCIiwiZmlsZSI6ImZvY3VzLXRyYXAuanMiLCJzb3VyY2VzQ29udGVudCI6WyJsZXQgRm9jYWxQb2ludCA9IHJlcXVpcmUoJy4vZm9jYWwtcG9pbnQnKVxubGV0IFJlYWN0ICAgICAgPSByZXF1aXJlKCdyZWFjdCcpXG5cbmxldCBGb2N1c1RyYXAgPSBSZWFjdC5jcmVhdGVDbGFzcyh7XG5cbiAgcHJvcFR5cGVzOiB7XG4gICAgYWN0aXZlIDogUmVhY3QuUHJvcFR5cGVzLmJvb2wsXG4gICAgb25FeGl0IDogUmVhY3QuUHJvcFR5cGVzLmZ1bmNcbiAgfSxcblxuICBnZXREZWZhdWx0UHJvcHMoKSB7XG4gICAgcmV0dXJuIHtcbiAgICAgIGFjdGl2ZSAgICA6IHRydWUsXG4gICAgICBjbGFzc05hbWUgOiAnZm9jdXMtdHJhcCdcbiAgICB9XG4gIH0sXG5cbiAgcmVuZGVyKCkge1xuICAgIGxldCB7IGFjdGl2ZSwgY2xhc3NOYW1lLCBjaGlsZHJlbiwgZWxlbWVudCwgb25FeGl0IH0gPSB0aGlzLnByb3BzXG5cbiAgICBpZiAoIWFjdGl2ZSApIHJldHVybiBudWxsXG5cbiAgICByZXR1cm4gKFxuICAgICAgPGRpdiBjbGFzc05hbWU9eyBgJHsgY2xhc3NOYW1lIH0td3JhcHBlcmAgfSBvbktleVVwPXsgdGhpcy5fb25LZXlVcCB9PlxuICAgICAgICA8ZGl2IGFyaWEtaGlkZGVuPVwidHJ1ZVwiIGNsYXNzTmFtZT17IGAkeyBjbGFzc05hbWUgfS1iYWNrZHJvcGAgfSBvbkNsaWNrPXsgb25FeGl0IH0gLz5cbiAgICAgICAgPEZvY2FsUG9pbnQgcmVmPSdmb2N1cycgY2xhc3NOYW1lPXsgY2xhc3NOYW1lIH0gZWxlbWVudD17IGVsZW1lbnQgfT5cbiAgICAgICAgICB7IGNoaWxkcmVuIH1cbiAgICAgICAgPC9Gb2NhbFBvaW50PlxuICAgICAgPC9kaXY+XG4gICAgKVxuICB9LFxuXG4gIF9vbktleVVwKGUpIHtcbiAgICBpZiAoZS5rZXkgPT09ICdFc2NhcGUnICYmICdvbkV4aXQnIGluIHRoaXMucHJvcHMpIHtcbiAgICAgIHRoaXMucHJvcHMub25FeGl0KClcbiAgICB9XG4gIH1cbn0pXG5cbm1vZHVsZS5leHBvcnRzID0gRm9jdXNUcmFwXG4iXX0=


//////////////////
// WEBPACK FOOTER
// ./~/react-focus-trap/src/focus-trap.js
// module id = 1823
// module chunks = 0